import React, { useEffect, useState } from 'react';
import { 
    Flex,
    Text,
    Button,
    IconButton,
    Image,
    Tooltip,
    Input,
    useDisclosure,
    Alert,
    AlertIcon,
    Grid,
    GridItem
} from '@chakra-ui/react';

import { MinusIcon } from '@chakra-ui/icons';
import { FaPlus } from "react-icons/fa";
import icon2 from '../../../assets/icons/package.svg';
import ModalPrintImage from '../../ModalPrintImage';

import { formatterValue, capitalizeFirstLetter } from '../../../resource/validate';
import { 
    selectTotalAmountRetail
} from '../../../hooks/slices/counterSlice';
import { useSelector } from 'react-redux';

const DescriptionMb = ({ previewImage, setImg, images, data, colors, colorsProduct, setSelectedColor, selectedColor, printingType, handleSubmitToCart, itemSelected, setItemSelected }) => {
    const totalAmount = useSelector(selectTotalAmountRetail);
    const { isOpen, onOpen, onClose } = useDisclosure();
    //const [selectedColor, setSelectedColor] = useState(null);
    //const [itemSelected, setItemSelected] = useState(data.items[0]);
    const [price, setPrice] = useState(0);
    const [amount, setAmount] = useState(0);
    const [values, setValues] = useState({
        num: 0
    });

    useEffect(() => {
        if (data) {
            if(totalAmount >= 15001){
                let unitRetailPrice = data.items[0]?.wholesale_price ? data.items[0]?.wholesale_price : (data.items[0]?.retail_price ? data.items[0]?.retail_price : 0);
                setValues({
                    ...values,
                    unitPrice: parseFloat(unitRetailPrice).toFixed(2),
                });
            }else{
                let unitRetailPrice = data.items[0]?.retail_price ? data.items[0]?.retail_price : (data.items[0]?.wholesale_price ? data.items[0]?.wholesale_price : 0);
                setValues({
                    ...values,
                    unitPrice: parseFloat(unitRetailPrice).toFixed(2),
                });
            }
        }
    }, []);

    useEffect(()=>{
        calculateTotal()
    },[amount, printingType]) 

    const calculateTotal = () => {
        let printing_unitary = 0;
        if(printingType !== 'none'){
            switch(printingType){
                case 'laser': {
                    if (values.amount <= 99) {
                      printing_unitary = 25;
                    } else {
                      printing_unitary = 15;
                    }
                    break;
                }
                case 'serigrafia': {
                    if (values.amount <= 99) {
                      printing_unitary = 8;
                    } else if (values.amount > 99 && values.amount <= 149) {
                      printing_unitary = 5;
                    } else {
                      printing_unitary = 3;
                    }
                    break;
                }
                default: {
                    printing_unitary = 0;
                    break;
                }
            }

        }
        const printing_total = printing_unitary * values.amount;
        const totalRetail = (data.items[0]?.retail_price * values.amount) + printing_total;
        let total = values.unitPrice * values.amount;
        total += printing_total;
        let unitPrice = data.items[0]?.retail_price ? data.items[0]?.retail_price : (data.items[0]?.wholesale_price ? data.items[0]?.wholesale_price : 0);
        if(total >= 15001 || totalAmount >= 15001 || totalRetail >= 15001 || (totalRetail + totalAmount) >= 15001){
            unitPrice = data.items[0]?.wholesale_price;
        }else{
            unitPrice = data.items[0]?.retail_price;
        }
        setValues({
            ...values,
            unitPrice: parseFloat(unitPrice).toFixed(2),
        })
    }

    const changeNumProducts = (nums) => {
        setValues({
            ...values,
            num: nums < 0 ? 0 : nums
        }) 
        setAmount(nums)
    }

    const handleChange = (e) => {
        setValues({
            ...values,
            [e.target.name]: parseInt(e.target.value)
        })
    }

    useEffect(() => {
        const prices = []
        data.items.map((item)=>{
            prices.push(item.wholesale_price)
        })
        setPrice(Math.min(...prices));
    },[colors])

    const handleChangeSelected = (color, sku) => {
        setSelectedColor(color);
        const item = data.items.filter((item)=>item.sku === sku)[0]
        setItemSelected(item)
        setPrice(item.wholesale_price);
    }

    useEffect(() => {
        if(selectedColor) {
            const filterProductColors = data?.items.filter(item => item.color === selectedColor.toUpperCase());
            const imgUrl = filterProductColors[0].images?.images_item[0];
            setImg(imgUrl)
        }
    }, [selectedColor]);

    const validateData = () => {
        if (itemSelected?.stock !== "0") {
            if (selectedColor && values.num !== 0 && values.num <= itemSelected?.stock) {
                return false;
            }
        }
        return true;
    }

    /*const addProductShoppingCart = () => {
        if (values.num > 0 && selectedColor) {
            let calcTotalPrice = price * values.num;
            const filterItem = data.items?.filter(element => element.color === selectedColor);
            const product = {
                sku: filterItem[0].sku,
                code_item: filterItem[0].code,
                unit_price: parseFloat(filterItem[0].wholesale_price),
                total_price: parseFloat(calcTotalPrice),
                quantity: values.num,
                name: data.name,
                category: data.category,
                color: selectedColor.toUpperCase(),
                image: previewImage,
                productsPreview: filterItem,
                printing: { type: "", price:  0 }
            }
            dispatch(
                setProducts({products: [
                    ...productsStore, product
                ]})
            );
            toast.success("¡Se ha agregado correctamente el nuevo producto!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    }*/

    const handleSubmit = () => {
        if (validateData() === false) {
            handleSubmitToCart(values.num, values.unitPrice);
        }
    }

    return ( 
        <>
            <Flex fontSize={"14px"} fontWeight={400} color={"#424242"} alignItems={"center"}>
                <Text as={"b"}>Colores:</Text>
                <Grid
                    w="100%"
                    pl={2}
                    templateColumns={"repeat(5, 1fr)"}
                >
                    {colorsProduct.map((item, index) => (
                        <GridItem key={`color-${index}`} >
                            <Tooltip hasArrow label={item.color} bg='gray.300' color='black'>
                                <Text
                                    marginRight={"1px"}
                                    cursor="pointer"
                                    fontSize={"50px"}
                                    color={item.color === "BLANCO" ? "#F4F4F4" :  item.hex}
                                    onClick={() => {
                                        handleChangeSelected(item.color, item.sku)
                                    }}
                                >
                                    &#9679;
                                </Text>
                            </Tooltip>
                        </GridItem>
                    ))}
                </Grid>
            </Flex>
            <Flex mt={5} flexDirection={"column"}>
                {selectedColor ?
                    <Flex>
                        <Text as={"b"}>Color seleccionado:</Text>
                        <Text ml={2}>{capitalizeFirstLetter(selectedColor)}</Text>
                    </Flex>
                    : null
                }
                <Flex mt={4} mb={1}>
                    <Text fontSize={"12px"} fontWeight={400} color={"#383838"}>Desde</Text>
                </Flex>
                <Flex alignItems={"center"}>
                    <Text mr={5} fontSize={"26px"} fontWeight={700} color={"#383838"}>{formatterValue(price)} <Text fontSize={"12px"} fontWeight={500} color={"#383838"} display={"inline-block"}>+ IVA</Text></Text>
                </Flex>
                {printingType ?
                    <Flex mt={2}>
                        <Text as={"b"} fontSize={'sm'}>Tipo de impresión seleccionada:</Text>
                        <Text ml={2} fontSize={'sm'}>{capitalizeFirstLetter(printingType === 'laser' ? 'Láser' : (printingType === 'serigrafia' ? 'Serigrafía' : 'Sin impresión'))}</Text>
                    </Flex>
                    : null
                }
            </Flex>
            <Flex mt={8} flexDirection={"column"}>
                <Flex justifyContent={"center"} alignItems={"center"}>
                    <IconButton
                        w={"37px"} h={"37px"}
                        bg={"#D0D0D2"}
                        onClick={() => changeNumProducts(values.num - 1)}
                        boxShadow={"rgb(221, 221, 221) 0px 4px 8px 0px"}
                        color={"#383838"}
                        fontSize={"16px"}
                        icon={<MinusIcon />}/>
                    <Input 
                        name='num' type='number' m={"0px 1rem"}
                        onChange={handleChange} value={values.num} fontWeight={500} fontSize={"16px"} 
                        min={0} 
                        max={itemSelected?.stock}
                        width={"80px"} height={"40px"} />
                    <IconButton
                        w={"37px"} h={"37px"}
                        bg='#31508C'
                        onClick={() => changeNumProducts(values.num + 1)}
                        boxShadow={"rgb(221, 221, 221) 0px 4px 8px 0px"}
                        color={"#FFF"}
                        fontSize={"16px"}
                        _hover={{
                            bg: '#24437E'
                        }}
                        icon={<FaPlus />}/>
                </Flex>
                <Flex justifyContent={"center"} mt={5}>
                    <Button w={"430px"} fontSize={"14px"} fontWeight={500}
                        _hover={{
                            bg: "#063D5F"
                        }}
                        //onClick={() => addProductShoppingCart()}
                        onClick={() => handleSubmit()}
                        isDisabled={validateData()}>Agregar al carrito
                    </Button>
                </Flex>
            </Flex>
            <Alert status='info' mt={4} display={selectedColor ? "none" : "flex"}>
                <AlertIcon />
                Selecciona un color para agregar al carrito de compra
            </Alert>
            <Flex mt={5} h={"66px"} border={"1px solid"} borderTopColor={"#CCCCCC"} borderBottomColor={"#CCCCCC"} borderLeftColor={"transparent"} borderRightColor={"transparent"}>
                <Flex  alignItems={"center"}>
                    <Image src={icon2} width={"32px"} height={"32px"} alt='icon'/>
                    <Text ml={2}>{itemSelected?.stock} en stock</Text>
                </Flex>
            </Flex>
            <Flex mt={5} justifyContent={"center"}>
                <Button onClick={onOpen} type='button' w={"430px"} fontSize={"14px"} fontWeight={500} color={"accent.500"} borderColor={"accent.500"} variant='outline'>Ver previsualización de impresión</Button>
            </Flex>
            {isOpen ?
                    <ModalPrintImage
                        isOpen={isOpen}
                        onClose={onClose}
                        category={data.name.toUpperCase()}
                        product={previewImage} />
                : null
            }
        </>
    );
}
 
export default DescriptionMb;